import { render, staticRenderFns } from "./AlienSymbol.vue?vue&type=template&id=cdfcacba&scoped=true&"
import script from "./AlienSymbol.vue?vue&type=script&lang=ts&"
export * from "./AlienSymbol.vue?vue&type=script&lang=ts&"
import style0 from "./AlienSymbol.vue?vue&type=style&index=0&id=cdfcacba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfcacba",
  null
  
)

export default component.exports